import React from 'react';
import { BadgeCheck, MapPin, Headset, TrendingDown, ShieldCheck, Wrench } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockFeatures } from '../mock';

const iconMap = {
  'badge-check': BadgeCheck,
  'map-pin': MapPin,
  headset: Headset,
  'trending-down': TrendingDown,
  'shield-check': ShieldCheck,
  wrench: Wrench
};

export const WhyUsSection = () => {
  return (
    <section id="why-us" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">Why Choose Us</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
            Your Trusted Medical Equipment Partner
          </h2>
          <p className="text-lg text-slate-600">
            We combine quality, reliability, and exceptional service to deliver the best medical equipment solutions in India.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <Card
                key={feature.id}
                className="border-slate-200 hover:border-teal-300 hover:shadow-lg transition-all duration-300 bg-white"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-teal-50 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="text-teal-600" size={24} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{feature.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Trust Section */}
        <div className="mt-16 bg-slate-50 rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Pan India Service Network</h3>
              <p className="text-slate-600 leading-relaxed mb-6">
                With a presence in over 28 cities across India, we ensure prompt service and support wherever you are. Our dedicated team of engineers and technicians are always ready to assist you.
              </p>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2"></div>
                  <span className="text-slate-700">Major metro cities and tier-2 cities covered</span>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2"></div>
                  <span className="text-slate-700">Rapid response time for service requests</span>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2"></div>
                  <span className="text-slate-700">Dedicated account managers for enterprise clients</span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">North</div>
                <p className="text-slate-600 text-sm">Delhi, Punjab, UP, Rajasthan</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">South</div>
                <p className="text-slate-600 text-sm">Bangalore, Hyderabad</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">East</div>
                <p className="text-slate-600 text-sm">Kolkata, Odisha, Bihar, Jharkhand</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">West</div>
                <p className="text-slate-600 text-sm">Pune, Bhopal, Raipur, Bhilai</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};